import { APIResponse } from '@supplement-bacon/react-toolkit/models'
import { SBAPI } from '@supplement-bacon/react-toolkit/utils'
import { TableParams } from '@supplement-bacon/sb-table-filters'
import { Event, EventParticipationStats } from '../models/Event'
import { EVENTS_URL } from '../utils/urls'

const fetchEvents = (params: TableParams) =>
  SBAPI.FetchPaginated<Event[]>(EVENTS_URL, params)

const fetchEventById = (id: number, params?: TableParams) =>
  SBAPI.Fetch<Event>(`${EVENTS_URL}/${id}`, params)

const createEvent = (event: FormData) => SBAPI.Post(EVENTS_URL, event)

const updateEvent = (event: FormData) =>
  SBAPI.Post(`${EVENTS_URL}/${event.get('id')}`, event)

const deleteEvent = (event: Event) => SBAPI.Delete(`${EVENTS_URL}/${event.id}`)

const fetchEventStats = (
  eventId: number
): Promise<APIResponse<EventParticipationStats>> =>
  SBAPI.Fetch(`${EVENTS_URL}/${eventId}/participations/stats`)

export {
  createEvent,
  deleteEvent,
  fetchEventById,
  fetchEvents,
  fetchEventStats,
  updateEvent,
}
